import {plainToInstance} from "class-transformer";
import ServiceMainApi from "@/services/v2/service-main-api/ServiceMainApi";
import AgentsAmountRanges from "@models/errors/components/AgentsAmountRanges";
import ModelLightRanges from "@models/v2/ranges/ModelLightRanges";

export default class RepositoryRanges {
	public async fetchWithdrawalRanges(requisiteId: number) {
		const response = await ServiceMainApi.of().get<{ data: object }>("/api/mobile/client/withdrawals/amount_range", {
			requisite_id: requisiteId
		});

		return plainToInstance(AgentsAmountRanges, response.data, {
			excludeExtraneousValues: true,
			excludePrefixes: ['_']
		});
	}

	public async fetchPurchaseLightRanges() {
		let { data } = await ServiceMainApi.of().get<{ data: object }>('/api/mobile/client/payments/sumRange', {
			all_ranges: true
		});

		return plainToInstance(ModelLightRanges, data, {
			excludeExtraneousValues: true,
			excludePrefixes: ['_']
		});
	}
}
